<template>
  <p class="flex items-start gap-2 text-sm">
    <span
      class="flex h-5 w-5 shrink-0 items-center justify-center rounded bg-primary-50 text-xs font-semibold text-primary-950"
      :class="{ '!w-auto !bg-primary px-2 text-white': !!section.tag }"
    >
      {{ index }}

      <template v-if="section.tag">
        <app-divider class="mx-2 border-primary-300" vertical />
        {{ section.tag }}
      </template>
    </span>

    {{ section.title }}
  </p>
</template>

<script lang="ts" setup>
import type { CourseProgramChapterSectionView } from "@pollen/core/model/course.model";

defineProps<{
  index: number;
  section: CourseProgramChapterSectionView;
}>();
</script>
